<template>
  <div class="container">
    <!-- Page title -->
    <div class="d-flex justify-content-center">
      <h1>{{ $t('EnduserChat.page_title') }}</h1>
    </div>

    <!-- Tab navigation (ChatLayout と同じ nav-underline パターン) -->
    <nav class="nav nav-container nav-underline justify-content-center">
      <router-link class="nav-link" to="/enduser-chat/settings">{{ $t('EnduserChat.tab_settings') }}</router-link>
      <router-link class="nav-link" to="/enduser-chat/talks">{{ $t('EnduserChat.tab_talks') }}</router-link>
      <router-link class="nav-link" to="/enduser-chat/usage">{{ $t('EnduserChat.tab_usage') }}</router-link>
      <router-link class="nav-link" to="/chats">{{ $t('EnduserChat.back') }}</router-link>
    </nav>
    <br>
    <br>

    <!-- child views -->
    <router-view></router-view>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "EnduserChatLayout",
});
</script>
